module.exports = __webpack_public_path__ + "img/participant.43a340f4.svg";